import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useMount } from 'react-use';
import { ratingApi } from 'apis/rating';
import { SurveyLanguageTableRow } from './row/surveyLanguageTableRow';
export function SurveyLanguagesTable(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [readRatingSettings, { data: readRatingSettingsResponse, isFetching: readRatingSettingsIsFetching, isSuccess: readRatingSettingsIsSuccess, },] = ratingApi.useLazyReadRatingSettingsQuery();
    const listLanguageSettings = useCallback(() => {
        readRatingSettings({
            parentId: props.surveyRatingSettingsId,
            level: 'language',
            /**
             * Once we support multiple surveys we will this will have to come from
             * the survey rating settings object
             */
            surveyType: 'text_to_speech',
        });
    }, [props.surveyRatingSettingsId, readRatingSettings]);
    useMount(() => {
        listLanguageSettings();
    });
    useEffect(() => {
        var _a;
        setSurveyLanguagesSettings((_a = readRatingSettingsResponse === null || readRatingSettingsResponse === void 0 ? void 0 : readRatingSettingsResponse.data.rating_settings) !== null && _a !== void 0 ? _a : []);
        setIsLoading(readRatingSettingsIsFetching);
    }, [readRatingSettingsResponse, readRatingSettingsIsFetching]);
    const [surveyLanguages, setSurveyLanguagesSettings] = useState([]);
    const emptyState = useMemo(() => {
        return readRatingSettingsIsSuccess && surveyLanguages.length < 1
            ? {
                title: 'No configured languages',
                description: 'Click "Add language" to set up a language for your CSAT survey.',
            }
            : undefined;
    }, [readRatingSettingsIsSuccess, surveyLanguages]);
    return (_jsxs(Table, Object.assign({ framed: true, stickyHeader: true, headerWithBackground: true, loadingFailed: !readRatingSettingsIsSuccess, loadingStrategy: "spinner", loading: isLoading, emptyState: emptyState }, { children: [_jsx(Table.Thead, { children: _jsxs(Table.Tr, { children: [_jsx(Table.Th, Object.assign({ columnId: "language" }, { children: "Language" })), _jsx(Table.Th, Object.assign({ columnId: "priority", width: "0" }, { children: "Enabled" })), _jsx(Table.Th, { columnId: null, width: "0" })] }) }), _jsx(Table.Tbody, { children: surveyLanguages.map((settings) => (_jsx(SurveyLanguageTableRow, { languageSettings: settings, handleGoToLanguage: props.handleGoToLanguage, onDelete: listLanguageSettings }, settings.id))) })] })));
}
